import { render, staticRenderFns } from "./ProductSummaryCost.vue?vue&type=template&id=1f33b2ac&"
import script from "./ProductSummaryCost.vue?vue&type=script&lang=js&"
export * from "./ProductSummaryCost.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports